export const contactData = [
  {
    type: "phone",
    icon: "feather icon-phone-call",
    title: "Phone Number",
    link: "tel:(212)-708-129950",
    text: "(212)-708-129950",
  },
  {
    type: "email",
    icon: "feather icon-mail",
    title: "Email Address",
    link: "mailto:contact@openlluna.com",
    text: "contact@openlluna.com",
  },
  {
    type: "location",
    icon: "feather icon-map-pin",
    title: "Location",
    link: "#;",
    text: "192 Mhamid,  Marrakech Morroco ,",
  },
  {
    type: "hours",
    icon: "feather icon-clock",
    title: "Opening Hours",
    link: "#;",
    text: "Mon - Sat (10.00AM - 05.30PM)",
  },
];
